import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import PageHero from "./PageHero";

// Image Assets
import heroBg from "../assets/membership.jpg";
import eligibilityImg from "../assets/youth.jpg";
import typesBg from "../assets/orphans.jpg";
import cessationBg from "../assets/homeless.jpg";

// React Icons
import { 
    FaCheckCircle, 
    FaExclamationTriangle, 
    FaUserCheck, 
    FaUsers, 
    FaUserShield, 
    FaHandshake 
} from "react-icons/fa";

export default function MembershipContent(props) {
    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Initialization space if needed
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <div className="mwadeo-membership-container">
                {/* 1. PageHero Component */}
                <PageHero 
                    kicker="JOIN MWADEO COMMUNITY" 
                    title="Membership & Community Engagement" 
                    bgImage={heroBg} 
                />

                {/* 2. Eligibility Section */}
                <section className="mwadeo-mb-eligibility py-5 bg-white">
                    <div className="container py-4">
                        <div className="row g-5 align-items-center">
                            <div className="col-12 col-lg-6">
                                <span className="badge bg-primary text-white text-uppercase letter-spacing-1 fw-bold px-3 py-2 mb-3">
                                    ARTICLE 10: QUALIFICATIONS
                                </span>
                                <h2 className="title-font-bold text-dark display-6 mb-4">
                                    Who Can Become a Member?
                                </h2>
                                <p className="font-regular text-muted lh-lg mb-4">
                                    Membership to MWADEO is voluntary and open to any individual who has attained the age of 18 years and above, is of sound mind, and is ready to join hands in supporting and promoting the vision, mission, and objectives of the Organization.
                                </p>
                                
                                <div className="row g-3">
                                    <div className="col-12 col-sm-6">
                                        <div className="d-flex align-items-center gap-2 p-2 bg-light rounded-3">
                                            <FaUserCheck className="primaryColor-text flex-shrink-0" size={16} />
                                            <span className="font-regular small fw-semibold text-dark">
                                                Voluntary participation
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="d-flex align-items-center gap-2 p-2 bg-light rounded-3">
                                            <FaUserCheck className="primaryColor-text flex-shrink-0" size={16} />
                                            <span className="font-regular small fw-semibold text-dark">
                                                18 years & above
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="d-flex align-items-center gap-2 p-2 bg-light rounded-3">
                                            <FaUserCheck className="primaryColor-text flex-shrink-0" size={16} />
                                            <span className="font-regular small fw-semibold text-dark">
                                                Sound mind & dedication
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="d-flex align-items-center gap-2 p-2 bg-light rounded-3">
                                            <FaUserCheck className="primaryColor-text flex-shrink-0" size={16} />
                                            <span className="font-regular small fw-semibold text-dark">
                                                Alignment with MWADEO mission
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-lg-6">
                                <div className="mwadeo-mb-img-container position-relative rounded-4 overflow-hidden shadow-lg">
                                    <img src={eligibilityImg} alt="MWADEO Membership" className="img-fluid w-100 object-fit-cover" />
                                    <div className="mwadeo-mb-img-badge position-absolute bottom-0 start-0 m-4 p-3 bg-white rounded-3 shadow">
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="mwadeo-badge-icon rounded-circle d-flex align-items-center justify-content-center">
                                                <FaHandshake size={22} />
                                            </div>
                                            <div>
                                                <h6 className="title-font-bold mb-0 text-dark">
                                                    Voluntary Joining
                                                </h6>
                                                <small className="text-muted">
                                                    Nationwide Tanzania
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 3. Types of Members Section */}
                <section className="mwadeo-mb-types-section position-relative py-5" style={{ backgroundImage: `url(${typesBg})` }}>
                    <div className="mwadeo-primary-overlay"></div>
                    <div className="container position-relative z-3 py-4">
                        <div className="text-center max-w-700 mx-auto mb-5">
                            <span className="text-warning text-uppercase fw-bold letter-spacing-2 small">
                                MWADEO CONSTITUTION
                            </span>
                            <h2 className="title-font-bold text-white display-6 mt-1 mb-3">
                                ARTICLE 11: Categories of Membership
                            </h2>
                            <div className="mwadeo-divider-line bg-warning mx-auto"></div>
                        </div>

                        <div className="row g-4">
                            {/* Founder Members */}
                            <div className="col-12 col-md-6">
                                <div className="mwadeo-glass-card p-4 p-md-5 h-100 rounded-4 d-flex flex-column justify-content-between">
                                    <div>
                                        <div className="d-flex align-items-center gap-3 mb-3">
                                            <div className="mwadeo-icon-box rounded-circle bg-warning text-dark d-flex align-items-center justify-content-center">
                                                <FaUserShield size={20} />
                                            </div>
                                            <h3 className="title-font-bold text-white m-0">
                                                1. Founder Members
                                            </h3>
                                        </div>
                                        <p className="font-regular text-white-80 lh-lg mb-0">
                                            These are members who took the initial initiative and establishing actions to form and register MWADEO.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Ordinary Members */}
                            <div className="col-12 col-md-6">
                                <div className="mwadeo-glass-card p-4 p-md-5 h-100 rounded-4 d-flex flex-column justify-content-between">
                                    <div>
                                        <div className="d-flex align-items-center gap-3 mb-3">
                                            <div className="mwadeo-icon-box rounded-circle bg-warning text-dark d-flex align-items-center justify-content-center">
                                                <FaUsers size={20} />
                                            </div>
                                            <h3 className="title-font-bold text-white m-0">
                                                2. Ordinary Members
                                            </h3>
                                        </div>
                                        <p className="font-regular text-white-80 lh-lg mb-0">
                                            These are individuals who join MWADEO after its establishment and formal registration upon meeting all qualifications.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 4. Rights and Obligations Section */}
                <section className="mwadeo-mb-rights py-5 bg-light">
                    <div className="container py-4">
                        <div className="text-center max-w-700 mx-auto mb-5">
                            <span className="badge bg-primary text-white text-uppercase letter-spacing-1 fw-bold px-3 py-2 mb-2">
                                RESPONSIBILITIES & PRIVILEGES
                            </span>
                            <h2 className="title-font-bold text-dark display-6 m-0">
                                ARTICLE 12: Rights & Obligations of Members
                            </h2>
                            <div className="mwadeo-divider-line bg-primary mt-3 mx-auto"></div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-10">
                                <div className="row g-3">
                                    <div className="col-12 col-md-6">
                                        <div className="mwadeo-right-item p-3 p-md-4 bg-white rounded-3 border h-100 d-flex align-items-start gap-3 shadow-xs">
                                            <FaCheckCircle className="primaryColor-text mt-1 flex-shrink-0" size={20} />
                                            <p className="font-regular text-secondary-dark mb-0 lh-base">
                                                To elect/vote and be elected/voted into leadership of the Organization.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="mwadeo-right-item p-3 p-md-4 bg-white rounded-3 border h-100 d-flex align-items-start gap-3 shadow-xs">
                                            <FaCheckCircle className="primaryColor-text mt-1 flex-shrink-0" size={20} />
                                            <p className="font-regular text-secondary-dark mb-0 lh-base">
                                                Right to be heard on all matters concerning individual membership & organization progress.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="mwadeo-right-item p-3 p-md-4 bg-white rounded-3 border h-100 d-flex align-items-start gap-3 shadow-xs">
                                            <FaCheckCircle className="primaryColor-text mt-1 flex-shrink-0" size={20} />
                                            <p className="font-regular text-secondary-dark mb-0 lh-base">
                                                To attend General Meetings and contribute to decision-making.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="mwadeo-right-item p-3 p-md-4 bg-white rounded-3 border h-100 d-flex align-items-start gap-3 shadow-xs">
                                            <FaCheckCircle className="primaryColor-text mt-1 flex-shrink-0" size={20} />
                                            <p className="font-regular text-secondary-dark mb-0 lh-base">
                                                Participate actively in all Organization activities as required.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="mwadeo-right-item p-3 p-md-4 bg-white rounded-3 border h-100 d-flex align-items-start gap-3 shadow-xs">
                                            <FaCheckCircle className="primaryColor-text mt-1 flex-shrink-0" size={20} />
                                            <p className="font-regular text-secondary-dark mb-0 lh-base">
                                                Receive updates and information on Organization progress through official channels.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="mwadeo-right-item p-3 p-md-4 bg-white rounded-3 border h-100 d-flex align-items-start gap-3 shadow-xs">
                                            <FaCheckCircle className="primaryColor-text mt-1 flex-shrink-0" size={20} />
                                            <p className="font-regular text-secondary-dark mb-0 lh-base">
                                                To pay fees that are prescribed by the General Meeting.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-12">
                                        <div className="mwadeo-right-item p-3 p-md-4 bg-white rounded-3 border h-100 d-flex align-items-start gap-3 shadow-xs">
                                            <FaCheckCircle className="primaryColor-text mt-1 flex-shrink-0" size={20} />
                                            <p className="font-regular text-secondary-dark mb-0 lh-base">
                                                To keep secret all confidential matters and internal decisions of the Organization.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 5. Cessation Section */}
                <section className="mwadeo-mb-cessation position-relative py-5" style={{ backgroundImage: `url(${cessationBg})` }}>
                    <div className="mwadeo-dark-overlay"></div>
                    <div className="container position-relative z-3 py-4">
                        <div className="text-center max-w-700 mx-auto mb-5">
                            <h2 className="title-font-bold text-white display-6 mb-2">
                                ARTICLE 13: Cessation of Membership
                            </h2>
                            <p className="font-regular text-white-75 mb-0">
                                A member shall cease to be a member under the following circumstances:
                            </p>
                            <div className="mwadeo-divider-line bg-warning mx-auto mt-3"></div>
                        </div>

                        <div className="row g-4">
                            <div className="col-12 col-sm-6 col-lg-4">
                                <div className="mwadeo-cessation-card p-4 h-100 rounded-3 border border-secondary border-opacity-25 bg-dark bg-opacity-50 backdrop-blur d-flex align-items-start gap-3">
                                    <FaExclamationTriangle className="text-warning mt-1 flex-shrink-0" size={20} />
                                    <div>
                                        <h5 className="title-font-bold text-white mb-2">
                                            By Resignation
                                        </h5>
                                        <p className="font-regular text-white-75 small mb-0 lh-base">
                                            Voluntary written notice to step down.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-4">
                                <div className="mwadeo-cessation-card p-4 h-100 rounded-3 border border-secondary border-opacity-25 bg-dark bg-opacity-50 backdrop-blur d-flex align-items-start gap-3">
                                    <FaExclamationTriangle className="text-warning mt-1 flex-shrink-0" size={20} />
                                    <div>
                                        <h5 className="title-font-bold text-white mb-2">
                                            Expulsion / Misbehavior
                                        </h5>
                                        <p className="font-regular text-white-75 small mb-0 lh-base">
                                            Failure to adhere to resolutions or Constitution.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-4">
                                <div className="mwadeo-cessation-card p-4 h-100 rounded-3 border border-secondary border-opacity-25 bg-dark bg-opacity-50 backdrop-blur d-flex align-items-start gap-3">
                                    <FaExclamationTriangle className="text-warning mt-1 flex-shrink-0" size={20} />
                                    <div>
                                        <h5 className="title-font-bold text-white mb-2">
                                            Absence from Meetings
                                        </h5>
                                        <p className="font-regular text-white-75 small mb-0 lh-base">
                                            Missing 3 consecutive General Meetings without reasonable notice.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-4">
                                <div className="mwadeo-cessation-card p-4 h-100 rounded-3 border border-secondary border-opacity-25 bg-dark bg-opacity-50 backdrop-blur d-flex align-items-start gap-3">
                                    <FaExclamationTriangle className="text-warning mt-1 flex-shrink-0" size={20} />
                                    <div>
                                        <h5 className="title-font-bold text-white mb-2">
                                            Mental Incapacity
                                        </h5>
                                        <p className="font-regular text-white-75 small mb-0 lh-base">
                                            Incapability to perform obligations due to severe mental disorder.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-4">
                                <div className="mwadeo-cessation-card p-4 h-100 rounded-3 border border-secondary border-opacity-25 bg-dark bg-opacity-50 backdrop-blur d-flex align-items-start gap-3">
                                    <FaExclamationTriangle className="text-warning mt-1 flex-shrink-0" size={20} />
                                    <div>
                                        <h5 className="title-font-bold text-white mb-2">
                                            Default on Fees
                                        </h5>
                                        <p className="font-regular text-white-75 small mb-0 lh-base">
                                            Failure to pay subscription fees for 5 years.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-4">
                                <div className="mwadeo-cessation-card p-4 h-100 rounded-3 border border-secondary border-opacity-25 bg-dark bg-opacity-50 backdrop-blur d-flex align-items-start gap-3">
                                    <FaExclamationTriangle className="text-warning mt-1 flex-shrink-0" size={20} />
                                    <div>
                                        <h5 className="title-font-bold text-white mb-2">
                                            Death
                                        </h5>
                                        <p className="font-regular text-white-75 small mb-0 lh-base">
                                            Decease of the individual member.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}